/* global Plotly */

import React, { Component } from 'react'

import numeral from 'numeral'
import Tooltip from 'react-simple-tooltip'
// import FechaActualizacionLabel from '../FechaActualizacionLabel'
import { withStyles } from '@material-ui/core/styles'

import Plot from 'react-plotly.js';


const styles = theme => ({
  container: {
    minHeight: 300,
    [theme.breakpoints.down('xs')]: {
      overflowX: 'auto'
    }
  },
  chart: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      width: 600
    }
  },
  tooltipContainer: {
    width: '11vw'
  }
})

class CompletitudInstalaciones extends Component {
  constructor (props) {
    super(props)
    this.state = {
      barData: null,
      calidad: null,
      isPending: true,
      tooltip: {
        show: false,
        content: '',
        position: [0, 0]
      },
      revision: 0,
      fechaActualizacion: null
    }
    this.typeProps = {
      marker: {
        validado: {
          color: '#00c172',
          line: {
            color: '#00c17200',
            width: 5
          },
        },
        enUso: {
          color: '#f5b245ff',
          line: {
            color: '#f5b24500',
            width: 5
          },
        },
        rechazado: {
          color: '#ff4e41ff',
          line: {
            color: '#ff4e4100',
            width: 5
          },
        },
        noRevisado: {
          color: '#cccccc',
          // color: '#668CCB',
          line: {
            color: '#668CCB00',
            width: 5
          },
        }
      }
    }
  }

  componentDidMount () {
    if (!this.props.dataset.isPending && this.props.dataset.data) {
      this.setChartData(this.props.dataset.data)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (
      !nextProps.dataset.isPending 
      && this.props.dataset.isPending !== nextProps.dataset.isPending
      && nextProps.dataset.data
    ) {
      this.setChartData(nextProps.dataset.data)
    }else {
    }
  }

  setChartData (data) {
    let barData = {
      validados: [],
      enUso: [],
      rechazados: [],
      noRevisados: [],
      tiposInstalaciones: [],
      calidad: []
    }

    const calidad = []


    data.forEach((d) => {
      	barData.validados.push((d.datos_validados) / d.datos_a_informar)
      	barData.enUso.push((d.datos_en_uso) / d.datos_a_informar)
      	barData.rechazados.push((d.datos_rechazados) / d.datos_a_informar)
      	barData.noRevisados.push((d.datos_no_revisados) / d.datos_a_informar)
      	barData.tiposInstalaciones.push(d.tipo_instalacion_nombre)
      	barData.calidad.push(`${numeral(d.completitud).format('0.00')}%`)
      	calidad.push(d.completitud)
      
    })

    this.setState({
      barData,
      calidad,
      isPending: false,
      fechaActualizacion: null
    })
  }

  plotHover (e) {
    const { classes } = this.props

    let tooltip = this.state.tooltip
    tooltip.show = true
    tooltip.position = [e.event.pageX - e.event.movementX, e.event.pageY]
    const instalationType = e.points[0].y

    let renderThis = {}
    this.props.dataset.data.forEach((x, i, v) => {
        const { tipo_instalacion_nombre, datos_en_uso, datos_informados, datos_no_revisados, datos_rechazados, datos_validados, datos_certificados, datos_a_informar, calidad, completitud } = x
        if(instalationType == tipo_instalacion_nombre)
        {
            renderThis = { datos_a_informar, datos_validados, datos_en_uso, datos_rechazados, datos_no_revisados, completitud }
        }
    })

    const contentA = e.points.map((p) => {
        
        return(
            <ul key={`${instalationType}-${p.data.name}`}>
                <li>
                    {`${numeral(renderThis.completitud).format('0.00')}%`}
                </li>
            </ul>
        )
    })
    
    const contentB = e.points.map((p) => {
         
        let denominator = renderThis.datos_validados + renderThis.datos_en_uso + renderThis.datos_rechazados + renderThis.datos_no_revisados
        return(
            <ul key={`${instalationType}-${p.data.name}`}>
                <li>
                    - {"Validado"}: {`${numeral(renderThis.datos_validados/denominator * 100).format('0.00')}%`}
                </li>
                <li>
                    - {"En uso"}: {`${numeral(renderThis.datos_en_uso/denominator * 100).format('0.00')}%`}
                </li>
                <li>
                    - {"Rechazados"}: {`${numeral(renderThis.datos_rechazados/denominator * 100).format('0.00')}%`}
                </li>
                <li>
                    - {"Sin anexos para validación"}: {`${numeral(renderThis.datos_no_revisados/denominator * 100).format('0.00')}%`}
                </li>
            </ul>
        )
    })
    
    tooltip.content = (
      <div className={classes.tooltipContainer}>
        <b>{instalationType}</b>
        <br />
        <br />
        <b>Completitud</b>
        {contentA}
        <br />
        <br />
        <b>Calidad</b>
        {contentB}
      </div>
    )
    this.setState({tooltip})
  }

  plotUnhover () {
    let tooltip = this.state.tooltip
    tooltip.show = false
    this.setState({tooltip})
  }

  render () {
    const { classes, title, divId } = this.props
    const { barData, isPending } = this.state
    console.log(barData);
    if (!barData || isPending){
      return <div>Cargando...</div>
    }

    const stackedGraphData = [
      {
        type: 'bar',
        width: 0.75,
        x: barData.validados,
        y: barData.tiposInstalaciones,
        name: "Validado",
        hoverinfo: 'none',
        orientation: 'h',
        cliponaxis: false,
        marker: this.typeProps.marker.validado,
      },
      {
        type: 'bar',
        width: 0.75,
        x: barData.enUso,
        y: barData.tiposInstalaciones,
        name: "En Uso",
        hoverinfo: 'none',
        orientation: 'h',
        cliponaxis: false,
        marker: this.typeProps.marker.enUso
      },
      {
        type: 'bar',
        width: 0.75,
        x: barData.rechazados,
        y: barData.tiposInstalaciones,
        name: "Rechazado",
        hoverinfo: 'none',
        orientation: 'h',
        cliponaxis: false,
        marker: this.typeProps.marker.rechazado
      },
      {
        type: 'bar',
        width: 0.75,
        x: barData.noRevisados,
        y: barData.tiposInstalaciones,
        name: "Sin anexos para validación",
        text: barData.calidad,
        textposition: 'outside',
        hoverinfo: 'none',
        orientation: 'h',
        cliponaxis: false,
        marker: this.typeProps.marker.noRevisado
      },
    ]

    const height = (25 * barData.tiposInstalaciones.length) + 200
    

    const stackedLayout = {
      title: title || "Completitud por Tipo de Instalación",
      titlefont: {
        family: 'DINRegular',
        siz: 26
      },
      plot_bgcolor: 'transparent',
      paper_bgcolor: 'transparent',
      font: {
        color: '#000'
      },
      height: height > 300 ? height : 300,
      xaxis: {
        showgrid: false,
        linecolor: '#97979C',
        range: [0, 1],
        rangemode: 'nonnegative',
        tickformat: '.0%',
        tickfont: {
          size: 10
        },
        automargin: true,
        fixedrange: true
      },
      yaxis: {
        showgrid: false,
        linecolor: '#97979C',
        tickfont: {
          size: 10
        },
        automargin: true,
        autorange: 'reversed',
        fixedrange: true
      },
      barmode: "stack",
      bargap: 200,
      showlegend: true,
      legend: {
        x: 1.08,
        font: {}
      }
    }

    return (
      <div className={classes.container} >
        {(!isPending && barData)
          ? 
            <Plot
              divId={divId || 'instalaciones-chart-stacked'}
              className={classes.chart}
              data={stackedGraphData}
              layout={stackedLayout}
              config={{
                displayModeBar: false,
                responsive: true
              }}
              onHover={(e) => this.plotHover(e)}
              onUnhover={() => this.plotUnhover()}
              revision={this.state.revision}
              onLegendClick={() => false}
              onLegendDoubleClick={() => false}
            />
          : <div>Cargando...</div>
        }
        {this.state.tooltip.show &&
          <Tooltip
            className='simple-tooltip'
            background='#fff'
            border='#ccc'
            color='#333'
            radius={3}
            fontSize='12px'
            fixed
            style={{
              width: 'auto',
              position: 'absolute',
              left: this.state.tooltip.position[0],
              top: this.state.tooltip.position[1]
            }}
            content={this.state.tooltip.content}
          />
        }
      </div>
    )
  }
}

export default withStyles(styles)(CompletitudInstalaciones)